(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/api-proxy/assets/javascripts/open-draws.js') >= 0) return;  svs.modules.push('/components/lb-utils/api-proxy/assets/javascripts/open-draws.js');
"use strict";


const ApiProxy = svs.isServer ? require('./proxy.es6') : svs.components.lbUtils.apiProxy.ApiProxy;
const OPEN_DRAW_STATE_ID = 2;
const TOPPTIPSET_PRODUCTS = new Set(['topptipset', 'topptipsetextra', 'topptipsetstryk']);
const normalizeProducts = function () {
  let products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  const normalizedProducts = products.filter(Boolean).map(product => {
    if (TOPPTIPSET_PRODUCTS.has(product)) {
      return 'topptipsetfamily';
    }
    return product;
  });
  return [...new Set(normalizedProducts)];
};
const isOpenDraw = draw => (draw === null || draw === void 0 ? void 0 : draw.drawStateId) === OPEN_DRAW_STATE_ID || (draw === null || draw === void 0 ? void 0 : draw.drawState) === 'Open';
const byCloseTimeAsc = (firstDraw, secondDraw) => {
  var _firstDraw$regCloseTi, _secondDraw$regCloseT;
  const firstCloseTime = new Date((_firstDraw$regCloseTi = firstDraw === null || firstDraw === void 0 ? void 0 : firstDraw.regCloseTime) !== null && _firstDraw$regCloseTi !== void 0 ? _firstDraw$regCloseTi : 0).getTime();
  const secondCloseTime = new Date((_secondDraw$regCloseT = secondDraw === null || secondDraw === void 0 ? void 0 : secondDraw.regCloseTime) !== null && _secondDraw$regCloseT !== void 0 ? _secondDraw$regCloseT : 0).getTime();
  return firstCloseTime - secondCloseTime;
};
const fetchOpenDraws = async function () {
  let {
    products,
    include,
    req
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const normalizedProducts = normalizeProducts(products);
  if (normalizedProducts.length === 0) {
    return [];
  }
  const query = include ? "?include=".concat(encodeURIComponent(include)) : '';
  const apiProxy = ApiProxy.create();
  const settledResponses = await Promise.allSettled(normalizedProducts.map(product => apiProxy.fetch("/draw/1/".concat(product, "/draws").concat(query), {
    method: 'GET',
    req
  })));
  const responses = settledResponses.filter(_ref => {
    let {
      status
    } = _ref;
    return status === 'fulfilled';
  }).map(_ref2 => {
    let {
      value
    } = _ref2;
    return value;
  });
  if (responses.length === 0) {
    throw settledResponses[0].reason;
  }
  return responses.flatMap(_ref3 => {
    let {
      draws = []
    } = _ref3;
    return Array.isArray(draws) ? draws : [];
  }).filter(isOpenDraw).sort(byCloseTimeAsc);
};
const exportedApi = {
  fetchOpenDraws,
  normalizeProducts
};
if (svs.isServer) {
  module.exports = exportedApi;
} else {
  setGlobal('svs.components.lbUtils.apiProxy.openDraws', exportedApi);
}

 })(window);